import React, { Component } from "react"

/* Components */
import { Input } from "../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { login } from "../api/Authorization"

/* Cookie */
import Cookies from "js-cookie"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../translates/translate"



/* Authorization Widget */
class Authorization extends Component {

    constructor() {
        super()

        this.state = {
            email: "",
            password: "",
            waiting: false,
            error: "",
        }
    }


    /* Login Action */
    login = () => {

        const { email, password } = this.state
        const { setToken } = this.props

        if (email === "" || email === null || email === undefined) {
            this._email.error(t("auth.error.emptyEmail"))
            return
        }

        if (/\S+@\S+\.\S+/.test(email) === false) {
            this._email.error(t("auth.error.invalidEmail"))
            return
        }

        if (password === "") {
            this._password.error(t("auth.error.emptyPassword"))
            return
        }

        if (password.length < 8) {
            this._password.error(t("auth.error.shortPassword"))
            return
        }

        this.setState({ waiting: true })

        this._password.error("")
        this._email.error("")

        /* SEND REQUEST to REST API */
        login({ email, password }).then((response) => {
            if (response.status === 200) {
                setToken(response.data.accessToken)
                localStorage.setItem("user", JSON.stringify(response.data.user))
                localStorage.setItem("token", response.data.accessToken)
                Cookies.set("refresh", response.data.refreshToken, { expires: 1 })
                window.location.reload()
            }
            else if (response.status === 400) {
                this.setState({ error: t("auth.error.invalidCredentials") })
            }
            else if (response.status === 404) {
                this._email.error(t("auth.error.userNotFound"))
            }
            else if (response.status === 401) {
                this._password.error(t("auth.error.wrongPassword"))
            }
            else if (response.status === 429) {
                this.setState({ error: t("auth.error.tooManyAttempts") })
            }
            else {
                this.setState({ error: t("auth.error.generic") })
            }
        }).catch(() => {
            this.setState({ error: t("auth.error.generic") })
        }).finally(() => {
            this.setState({ waiting: false })
        })

    }


    /* Draw button */
    _button = () => {

        const { waiting } = this.state

        if (waiting) {
            return <div className="button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.login()} className="button">{t("auth.login")}</div>
    }


    /* Clear */
    clear = () => {
        this.setState({ error: "" })
    }


    render = () => {

        const { email, password, error } = this.state

        return (
            <div className="authorization">

                <div className="game-logo">
                    <span>
                        <img src="/images/logo.png" alt="Logo" />
                    </span>
                    <div className="game-logo-box">
                        <h1>Game Center</h1>
                    </div>
                </div>


                <div className="authorization-wrapper">

                    <h2>{t("auth.title")}</h2>

                    <Input ref={(ref) => this._email = ref} label="Email" value={email} clear={() => this.clear()} onChange={(event) => this.setState({ email: event.target.value })} />
                    <Input ref={(ref) => this._password = ref} label={t("auth.password")} value={password} clear={() => this.clear()} onChange={(event) => this.setState({ password: event.target.value })} secure />

                    {error !== "" && <div className="error">{error}</div>}

                    {this._button()}

                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        language: state.language,
    }
}

export default connect(mapStateToProps)(Authorization)
